import { Link } from "react-router-dom";
import { Tag } from "antd";
import React from "react";

export const JobCard = ({ index, job }) => {
    return (
        <Link
            to={`/viec-lam/${job.Pk}`}
            key={index}
            className="grid relative grid-cols-5 h-full items-center border border-gray-200 bg-gray-100 p-2 rounded-lg hover:shadow-lg hover:cursor-pointer"
            style={{
                padding: "0",
            }}
        >
            {/* Hình ảnh */}
            <div className="col-span-1 mb-20 lg:mb-0 p-2">
                <img
                    src={`/${job.PhotoCompany}`}
                    alt="company-logo"
                    className="rounded-lg w-full"
                />
            </div>

            {/* Nội dung */}
            <div className="col-span-4 p-4 flex flex-col justify-between w-full">
                <h2 className="text-lg font-bold overflow-ellipsis overflow-hidden lg:whitespace-normal whitespace-nowrap hover:text-cyan-600">
                    {job.JobTitle}
                </h2>
                <p className="text-gray-500 line-clamp-1" >{job.JobCompanyName}</p>
                <div className="flex my-2 flex-wrap gap-2 lg:w-full lg:flex-row">
                    <Tag color={"blue"}
                        className="text-gray-500">{job.PlaceWork || "Liên hệ"}</Tag>
                    <Tag color={"green"}
                        className="text-gray-500">{job.JobSalary ? /^\d+$/.test(job.JobSalary) ? `${(+job.JobSalary).toLocaleString('vi-VN')}` : job.JobSalary : "Thỏa thuận"}</Tag>
                </div>
            </div>
        </Link>
    )
}